"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var Register_1 = require("./parts/Register");
var Register2_1 = require("./parts/Register2");
var findErrors_1 = require("lib/functions/findErrors");
var Label_1 = require("components/Label");
var Input_1 = require("components/Input");
var problems = [
    {
        id: "physical_problems",
        label: "Physical Problems",
        required: true
    },
    {
        id: "hearing_problems",
        label: "Hearing Problems",
        required: true
    },
    {
        id: "speach_problems",
        label: "Speach Problems",
        required: true
    },
    {
        id: "sight_problems",
        label: "Sight Problems",
        required: true
    },
    {
        id: "emotional_problems",
        label: "Emotional Problems",
        required: true
    }
];
var other_questions = [
    {
        id: "alcohol_recovery_program",
        question: "In the last five years, have you been enrolled in, required to enter into, or participated in any drug or alcohol revocery program or impaired practitioner programs?",
        required: true
    },
    {
        id: "mental_disorder",
        question: "In the last five years, have you been treated for, or had a recurrence of a diagnosed mental disorder or impairment?",
        required: true
    },
    {
        id: "physical_impairment",
        question: "In the last five years, have you been treated for, or had a recurrence of a diagnosed physical impairment?",
        required: true
    },
    {
        id: "adictive_disorder",
        question: "In the last five years, have you been treated for, or had a recurrence of a diagnosed addictive disorder?",
        required: true
    }
];
var rules = {};
var HealthHistory = (function (_super) {
    __extends(HealthHistory, _super);
    function HealthHistory(props) {
        var _this = _super.call(this, props) || this;
        _this.errors = {};
        _this.onChange = _this.onChange.bind(_this);
        _this.json_data = props.model.json_data;
        _this.onModel = _this.onModel.bind(_this);
        _this.isValid = _this.isValid.bind(_this);
        props.model.dispatcher.addListener(_this.onModel);
        problems.forEach(function (e) {
            var rulesForProblems = {};
            rulesForProblems[e.id] = {
                presence: e.required
            };
            rulesForProblems[e.id + "_disabilities"] = {
                presence: false
            };
            rulesForProblems[e.id + "_accomodations"] = {
                presence: false
            };
            rules = Object.assign(rules, rulesForProblems);
        });
        other_questions.forEach(function (e) {
            var rulesForOther = {};
            rulesForOther[e.id] = {
                presence: e.required
            };
            rules = Object.assign(rules, rulesForOther);
        });
        return _this;
    }
    HealthHistory.prototype.onModel = function () {
        this.json_data = this.props.model.json_data;
        this.forceUpdate();
    };
    HealthHistory.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.dispatcher.dispatch();
                this.props.model.addValidateFunction(this.constructor.name, this.isValid);
                return [2];
            });
        });
    };
    HealthHistory.prototype.componentWillUnmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.props.model.removeValidateFunction(this.constructor.name);
                this.props.model.dispatcher.removeListener(this.onModel);
                return [2];
            });
        });
    };
    HealthHistory.prototype.onChange = function (id, value) {
        this.json_data[id] = value;
        if (problems.find(function (p) { return p.id === id; })) {
            rules[id + "_disabilities"] = {
                presence: value === "yes"
            };
            rules[id + "_accomodations"] = {
                presence: value === "yes"
            };
        }
        this.forceUpdate();
    };
    HealthHistory.prototype.isValid = function () {
        console.log("Validate Health History");
        var _a = findErrors_1.findErrors(this.json_data, rules), isValid = _a.isValid, errors = _a.errors;
        this.errors = errors;
        return isValid;
    };
    HealthHistory.prototype.render = function () {
        var _a = this, json_data = _a.json_data, onChange = _a.onChange, errors = _a.errors;
        return (React.createElement("section", { className: "section-content" },
            React.createElement("h2", { className: "section-title" }, "HEALTH HISTORY"),
            problems.map(function (ed) { return (React.createElement(Register_1.Register, { key: ed.id, id: ed.id, label: ed.label, required: ed.required, json_data: json_data, onChange: onChange, errors: errors })); }),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-xs-12" },
                    React.createElement(Label_1.Label, { htmlFor: "other_disabilities", text: "Other" }),
                    React.createElement(Input_1.Input, { id: "other_disabilities", json_data: json_data, onChange: onChange, placeholder: "Explain other disabilities", type: "text", errors: errors }))),
            other_questions.map(function (q) { return (React.createElement(Register2_1.Register2, { key: q.id, id: q.id, question: q.question, json_data: json_data, onChange: onChange, errors: errors })); })));
    };
    __decorate([
        mobx_1.observable
    ], HealthHistory.prototype, "errors", void 0);
    HealthHistory = __decorate([
        mobx_react_1.observer
    ], HealthHistory);
    return HealthHistory;
}(react_1.Component));
exports.HealthHistory = HealthHistory;
//# sourceMappingURL=data:application/json;base64,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